import React from "react";
import { useTranslation } from "react-i18next";
import { FmCarouselData } from "..";
import { useIsMobile } from "../../Hooks";
import { ReleaseGraph } from "../../Models";
import useStyles from "./FmNutrientsWideTable.style";
import { TWO, FIVE } from "../../Utils/Consts";

interface FmNutrientsWideTableProps {
    title: string;
    tableData: any;
}

const FmNutrientsWideTable = ({ title, tableData }: FmNutrientsWideTableProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();
    const { t } = useTranslation();

    return (
        <div className={isMobile ? classes.container_mobile : classes.container}>
            {isMobile ? (
                <FmCarouselData tableData={tableData} />
            ) : (
                <>
                    <div className={classes.titles_container}>
                        <div className={classes.titles_leftSide}>
                            <span style={{ fontSize: 17 }}>
                                {title}
                                <span className={classes.smallLetters}>{t("multicoteTable.mesurmentUnit")}</span>
                            </span>
                        </div>

                        <div className={classes.titles_rightSide}>
                            {tableData.map((mon: any, index: number) => {
                                return <span key={index}>{mon.name}</span>;
                            })}
                        </div>
                    </div>

                    {/* 6 left Labels always there  */}
                    <div className={classes.table_container}>
                        <div className={classes.tableLeftSide_wideTable}>
                            <span className={classes.titleSmallWidth}>{t("wideTable.sideLabel.label1")}</span>
                            <span className={classes.titleSmallWidth}>
                                {t("wideTable.sideLabel.label2")}
                                <span className={classes.smallFont}>{TWO}</span>
                                {t("wideTable.sideLabel.label2_1")}
                                <span className={classes.smallFont}>{FIVE}</span>
                            </span>
                            <span className={classes.titleSmallWidth}>
                                {t("wideTable.sideLabel.label3")}
                                <span className={classes.smallFont}>{TWO}</span>
                                {t("wideTable.sideLabel.label2_1")}
                            </span>
                        </div>

                        <div className={classes.tableRightSide_wideSide}>
                            {/* N */}
                            <div className={classes.rightSide_row_wideTable}>
                                {tableData.map((mon: any, index: number) => {
                                    return <span key={index}>{mon.N.toFixed(2)}</span>;
                                })}
                            </div>

                            {/* P */}
                            <div className={classes.rightSide_row_wideTable}>
                                {tableData.map((mon: any, index: number) => {
                                    return <span key={index}>{mon.P.toFixed(2)}</span>;
                                })}
                            </div>

                            {/* K */}
                            <div className={classes.rightSide_row_wideTable}>
                                {tableData.map((mon: any, index: number) => {
                                    return <span key={index}>{mon.K.toFixed(2)}</span>;
                                })}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default FmNutrientsWideTable;
